import React, { forwardRef } from "react";
import { DragIndicatorMIcon } from "../icons/DragIndicatorMIcon";
import { TrackDragIcon } from "../icons/TrackDragIcon";
import { LengthIndicatorSC, TrackLengthIndicatorWrapperSC } from "./styled";

export interface TrackDragIndicatorProps {
  isLengthing: boolean;
  isStart?: boolean;
  handleLengthMouseDown?: (e: React.MouseEvent) => void;
  isHorizontal?: boolean;
}

export const TrackLengthChangeIndicator = forwardRef<HTMLDivElement, TrackDragIndicatorProps>(
  ({ isLengthing, handleLengthMouseDown, isStart, isHorizontal }, ref) => {
    return (
      <TrackLengthIndicatorWrapperSC
        lengthing={isLengthing.toString()}
        start={isStart?.toString()}
        horizontal={isHorizontal?.toString()}
      >
        <LengthIndicatorSC
          start={isStart?.toString()}
          ref={ref}
          onMouseDown={handleLengthMouseDown}
          horizontal={isHorizontal?.toString()}
        >
          {!isLengthing && <DragIndicatorMIcon horizontal={isHorizontal} />}
          {isLengthing && <TrackDragIcon />}
        </LengthIndicatorSC>
      </TrackLengthIndicatorWrapperSC>
    );
  },
);
